import { Api } from '../api';
import { statements } from '../endpoints';
import type { StatementEntity, StatementSearchParams } from './models';

export class StatementsApi extends Api {
  static getStatements = (searchParams: StatementSearchParams, signal?: AbortSignal) =>
    this.get<StatementEntity[]>(statements.getStatements(), {
      queryParams: { AccountId: searchParams.AccountId, From: searchParams.DateFrom, To: searchParams.DateTo },
      signal,
    });

  static downloadStatement = async (statementId: string, signal?: AbortSignal) =>
    await this.get<Blob>(statements.downloadStatement(), {
      queryParams: { statementId },
      headers: { Accept: 'application/pdf' },
      responseType: 'blob',
      signal,
    });
}
